import { IsOptional, IsBoolean } from 'class-validator';

export class DeleteCashTransactionGroupLinkResultDto {
  @IsOptional()
  @IsBoolean()
  success?: boolean;
}
